export const LOGIN_SUCCESS = 'login-success'
export const LOGOUT_SUCCESS = 'logout-success'
export const USER_INFO = 'user-info'
export const TOKEN_SUCCESS = 'token-success'
export const ALL_ROUTES_INFO = 'all-routes-info'
export const SET_MERCHANT_ID = 'set-merchant-id';
export const SET_ESCALATION_MATRIX = 'set-esclation-matrix';
export const SET_OPERATOR_TYPE = 'set-operator-type';
